import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { useEffect } from "react";
import {
  fetchSellerProduct,
  getproductById,
} from "../../../State/seller/sellerProductSlice";
import { ProductRes } from "../../../types/productType";
import { Button, IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../customer/data/Filter/color";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function ProductTable() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Use a default value to prevent undefined issues
  const { sellerProduct } = useAppSelector((store) => store);

  useEffect(() => {
    dispatch(fetchSellerProduct());
  }, [dispatch]);

  // Handle case when sellerProduct or its products array is undefined or empty
  if (!sellerProduct?.products || sellerProduct.products.length === 0) {
    return (
      <div>
        <h1>You have no displayed Products</h1>
      </div>
    );
  }
  if (!sellerProduct?.products) {
    return <p>Loading product details...</p>; // Prevents undefined errors
  }

  const handleNavigateEditPage = async (productId: number | undefined) => {
    if (!productId) {
      console.error("Error: Product ID is undefined!");
      return; // Prevents navigation errors
    }
   
    try {
      await dispatch(getproductById(productId)).unwrap();
      setTimeout(() => {
        navigate(`/seller/products/edit/${productId}`);
      }, 300);
    } catch (error) {
  
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Images</StyledTableCell>
            <StyledTableCell align="right">Title</StyledTableCell>
            <StyledTableCell align="right">Selling Price</StyledTableCell>
            <StyledTableCell align="right">Colors</StyledTableCell>
            <StyledTableCell align="right">Sizes</StyledTableCell>
            <StyledTableCell align="right">Stock</StyledTableCell>
            <StyledTableCell align="right">Update Product</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sellerProduct.products.map((item: ProductRes) => (
            <StyledTableRow key={item.id}>
              <StyledTableCell component="th" scope="row">
                <div className="flex gap-1 flex-wrap">
                  {/* Use optional chaining for images */}
                  {item.images?.length > 0 ? (
                    item.images.map((image, index) => (
                      <img
                        key={index}
                        className="w-20 rounded-md max-h-[10vh] object-contain "
                        alt="Product"
                        src={image}
                      />
                    ))
                  ) : (
                    <p>No Images Available</p>
                  )}
                </div>
              </StyledTableCell>

              <StyledTableCell align="right">
                {item?.title || "N/A"}
              </StyledTableCell>
              <StyledTableCell align="right">
                {item?.sellingPrice || "N/A"}
              </StyledTableCell>
              <StyledTableCell align="right">
                <Button size="small">
                  {item.details?.length ? (
                    <span style={{ display: "inline-flex", gap: 8 }}>
                      {Array.from(
                        new Set(item.details.map((d) => d.color))
                      ).map((color, i) => {
                        const match = colors.find((c) => c.name === color);
                        return (
                          <span
                            key={i}
                            style={{
                              width: 12,
                              height: 12,
                              borderRadius: "50%",
                              backgroundColor: match?.hex ?? "#ccc",
                              display: "inline-block",
                            }}
                          />
                        );
                      })}
                    </span>
                  ) : (
                    "N/A"
                  )}
                </Button>
              </StyledTableCell>
              {/* <StyledTableCell align="right">{item?.color || "N/A"}</StyledTableCell> */}
              <StyledTableCell align="right">
                <Button size="small">
                  {item.details?.length
                    ? item.details.map((d, index) => {
                        return (
                          <div key={index}>
                            {d.size}
                            {index < item.details.length - 1 && ","}
                          </div>
                        );
                      })
                    : "N/A"}
                </Button>
              </StyledTableCell>
              <StyledTableCell align="right">
                <Button size="small">{item?.quantity}</Button>
              </StyledTableCell>
              <StyledTableCell align="right">
                {item?.id && (
                  <IconButton
                    onClick={() => handleNavigateEditPage(item.id)}
                    size="small"
                    color="primary"
                  >
                    <Edit />
                  </IconButton>
                )}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
